import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AttListRaw = React.lazy(() => import(/* webpackChunkName: "AttList" */ './AttList'));
export const AttList = () => (React.createElement(Page, { title: "Attorney List", description: "Attorney List" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AttListRaw, null)))));
